<template>
  <page>
    <page-poster-with-image
      :headline="$t('rewards.poster.headline', { class: 'blue' })"
      :paragraph="$t('rewards.poster.paragraph')"
      src="/img/posters/rewardsPoster.png"
      :alt="$t('money.from.laptop')"
    />
    <rewards-group
      :headline="group1.headline"
      :iconSrc="group1.src"
      :iconAlt="group1.alt"
      :items="group1.items"
    />
    <img src="/img/rewards/bitmap.png" :alt="$t('money.from.laptop')" />
    <rewards-group
      :headline="group2.headline"
      :iconSrc="group2.src"
      :iconAlt="group2.alt"
      :items="group2.items"
    />
    <page-info-footer-row />
  </page>
</template>

<script>
import Page from '@/components/common/Page.vue';
import PagePosterWithImage from '@/components/common/PagePosterWithImage.vue';
import PageInfoFooterRow from '@/components/common/PageInfoFooterRow.vue';
import RewardsGroup from '@/components/rewards/RewardsGroup.vue';

export default {
  components: {
    Page,
    PagePosterWithImage,
    PageInfoFooterRow,
    RewardsGroup,
  },
  data() {
    return {
      group1: {
        headline: this.$t('rewards.group-1.headline'),
        src: 'img/icons/check.svg',
        alt: this.$t('rewards.group-1.iconAlt'),
        items: [
          [this.$t('rewards.group-1.item-1.paragraph-1'), this.$t('rewards.group-1.item-1.paragraph-2')],
          [this.$t('rewards.group-1.item-2.paragraph-1'), this.$t('rewards.group-1.item-2.paragraph-2')],
          [this.$t('rewards.group-1.item-3.paragraph')],
          [this.$t('rewards.group-1.item-4.paragraph')],
        ],
      },
      group2: {
        headline: this.$t('rewards.group-2.headline'),
        src: 'img/icons/notcheck.svg',
        alt: this.$t('rewards.group-2.iconAlt'),
        items: [
          [this.$t('rewards.group-2.item-1.paragraph')],
          [this.$t('rewards.group-2.item-2.paragraph')],
        ],
      },
    };
  },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/breakpoints';

img {
  margin-bottom: 100px;
  padding: 0 15px;
  max-width: $page-laptop-breakpoint;
  width: 100%;
}
</style>
